import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';


const Popup = ({ show, handleClose, text }) => {

    const handleCancel = () => {
        window.location.reload()
    }

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title>Acumen Translation Hub says</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <p>{text}</p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleCancel}>
                    Okay
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default Popup;
